var render = function render(){var _vm=this,_c=_vm._self._c;return _c('question-item',_vm._g(_vm._b({attrs:{"question":_vm.question,"operates":['copy','remove'],"more-operates":[],"seniors":['source', 'editor', 'image']}},'question-item',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }